import React from 'react';
import { IRestrictedContainer } from './IRestrictedContainer';
import { classNames } from '@features/utils/reactFunctions';
import padlock from './padlock.svg?url';
import * as style from './RestrictedContainerStyles.module.scss'

export const RestrictedContainer = (props: IRestrictedContainer) => (
    <div className={classNames(style.wrapper, props.center && style.wrapperCenter)}>
      <div>
        <div className={style.iconContainer}>
          <img alt="padlock" src={padlock} className={style.icon}/>
        </div>
        {props.children}
      </div>
    </div>
  );
